// define a namespace prefix for triggers to enrich eventCounters with info about different counter types
const makeContextualTriggerName = (input: string) =>
  `__contextual_prompt__${input}`;

export const CONTEXTUAL_TRIGGER_NAMES = {
  NON_HEADER_FOOTER_PBL: makeContextualTriggerName(
    'non-header-footer-prebuilt-added'
  ),
  CLASS_UPDATED: makeContextualTriggerName('class-created-or-modified'),
  HEADER_FOOTER_SELECTED: makeContextualTriggerName('header-footer-selected'),
  NON_SPECIAL_SECTION_SELECTED: makeContextualTriggerName(
    'non-special-section-selected'
  ),
  FIRST_SYMBOL_CLICKED: makeContextualTriggerName('symbol-clicked'),

  FIRST_CMS_ITEM_CLICKED_BLANK_SITE: makeContextualTriggerName(
    'first-cms-item-clicked-blank-site'
  ),

  FIRST_ECOMM_ITEM_CLICKED_BLANK_SITE: makeContextualTriggerName(
    'first-ecomm-item-clicked-blank-site'
  ),

  FIRST_ELEMENT_ADDED: makeContextualTriggerName('first-element-added'),
  FIRST_QS_ADDED: makeContextualTriggerName('first-qs-added'),
  QUICK_STACK_VIDEO_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'quick-stack-video-tutorial-triggered'
  ),

  CLASSES_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'classes-checklist-tutorial-triggered'
  ),

  CMS_BLANK_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'cms_blank-checklist-tutorial-triggered'
  ),

  CMS_TEMPLATE_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'cms_template-checklist-tutorial-triggered'
  ),

  SPACING_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'spacing-checklist-tutorial-triggered'
  ),

  STYLES_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'styles-checklist-tutorial-triggered'
  ),

  VIDEO_TUTORIALS_TRIGGERED: makeContextualTriggerName(
    'video-tutorials-triggered'
  ),

  IMAGES_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'images-tutorial-triggered'
  ),

  ASSETS_UPLOADED: makeContextualTriggerName('assets-uploaded'),

  ADD_LOCALES_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'add-locales-tutorial-triggered'
  ),

  ADD_ELEMENTS_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'add-elements-tutorial-triggered'
  ),

  NAVIGATOR_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'navigator-tutorial-triggered'
  ),

  DISPLAY_SETTINGS_VIDEO_TUTORIAL_TRIGGERED:
    'display-settings-video-tutorial-triggered',

  LIBRARIES_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'libraries_tutorial_triggered'
  ),
  LAYOUT_ELEMENT_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'layout_element_tutorial_triggered'
  ),
  CREATE_LAYOUT: makeContextualTriggerName('create_layout'),
  CREATE_LAYOUT_QS: makeContextualTriggerName('create_layout_qs'),
  NINE_BOX_FLEX_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'nine-box-flex-tutorial-triggered'
  ),
  NINE_BOX_GRID_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'nine-box-grid-tutorial-triggered'
  ),
  AISG_THEME_CLICKED: makeContextualTriggerName('aisg-theme-clicked'),
  AISG_THEME_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'aisg-theme-tutorial-triggered'
  ),
  PREVIEW_SITE_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'preview-site-tutorial-triggered'
  ),
  AISG_PAGE_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'aisg-page-tutorial-triggered'
  ),
  AISG_FTU_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'aisg-ftu-tutorial-triggered'
  ),
  AISG_SECTION_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'aisg-section-tutorial-triggered'
  ),
  AISG_HOVERED_SECTION_CONTROLS_CLICKED: makeContextualTriggerName(
    'aisg-hovered-section-controls-clicked'
  ),
  ORION_SYNC_STYLES_TRIGGERED: makeContextualTriggerName(
    'orion-sync-styles-triggered'
  ),
  ORION_ADD_CONTEXT_POPOVER_TRIGGERED: makeContextualTriggerName(
    'orion-add-context-popover-triggered'
  ),
  ORION_SITE_ADD_SECTION_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'orion-site-add-section-tutorial-triggered'
  ),
  ORION_SITE_CHANGE_LAYOUT_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'orion-site-change-layout-tutorial-triggered'
  ),
  ORION_SITE_GENERATE_PAGE_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'orion-site-generate-page-tutorial-triggered'
  ),
  ORION_SITE_PUBLISH_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'orion-site-publish-tutorial-triggered'
  ),
  PAGES_PANEL_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'pages-panel-tutorial-triggered'
  ),
  EDITOR_ROLE_ONBOARDING_TRIGGERED: makeContextualTriggerName(
    'editor-role-onboarding-triggered'
  ),
  MARKETER_ROLE_ONBOARDING_TRIGGERED: makeContextualTriggerName(
    'marketer-role-onboarding-triggered'
  ),
  OPEN_CANVAS_TUTORIAL_TRIGGERED: makeContextualTriggerName(
    'open-canvas-tutorial-triggered'
  ),
};

// define a namespace prefix for events to be able to distinguish events from triggers in eventCounters
const makeContextualEventName = (input: string) =>
  `__contextual_event__${input}`;

export const CONTEXTUAL_EVENT_KEYS = {
  NON_HEADER_FOOTER_PBL: makeContextualEventName(
    'non-header-footer-prebuilt-added'
  ),

  CLASS_CREATED: makeContextualEventName('class-created'),
  CLASS_UPDATED: makeContextualEventName('class-updated'),

  ELEMENT_ADDED: makeContextualEventName('element-added'),
  QS_ADDED: makeContextualEventName('quick-stack-added'),

  ASSETS_UPLOADED: makeContextualEventName('assets-uploaded'),

  VIDEO_TUTORIALS_TRIGGERED: makeContextualEventName(
    'video-tutorials-triggered'
  ),

  CMS_COLLECTION_CLICKED_BLANK_SITE: makeContextualEventName(
    'cms-collection-clicked-blank-site'
  ),
  CMS_COLLECTION_CLICKED_TEMPLATE: makeContextualEventName(
    'cms-collection-clicked-template'
  ),

  ECOMMERCE_ITEM_CLICKED_TEMPLATE: makeContextualEventName(
    'ecommerce-item-clicked-template'
  ),
  ECOMMERCE_ITEM_CLICKED_BLANK_SITE: makeContextualEventName(
    'ecommerce-item-clicked-blank-site'
  ),

  HEADER_FOOTER_SELECTED: makeContextualEventName('header-footer-selected'),

  NON_SPECIAL_SECTION_CLICKED: makeContextualEventName('section-clicked'),

  SYMBOL_CLICKED_TEMPLATE: makeContextualEventName('symbol-clicked-template'),

  DISPLAY_SETTINGS_VIDEO_TUTORIAL_TRIGGERED: makeContextualEventName(
    'display-settings-video-tutorial-triggered'
  ),

  QUICK_STACK_VIDEO_TUTORIAL_TRIGGERED: makeContextualEventName(
    'quick-stack-video-tutorial-triggered'
  ),

  DESIGNER_OPENED_WITH_LIBRARY_INSTALLED: makeContextualEventName(
    'designer-opened-with-library-installed'
  ),

  DESIGNER_SETTINGS_PANEL_OPENED: makeContextualEventName(
    'designer-settings-panel-opened'
  ),

  NINE_BOX_FLEX_TUTORIAL_TRIGGERED: makeContextualEventName(
    'nine-box-flex-tutorial-triggered'
  ),
  NINE_BOX_GRID_TUTORIAL_TRIGGERED: makeContextualEventName(
    'nine-box-grid-tutorial-triggered'
  ),
  AISG_THEME_CLICKED: makeContextualEventName('aisg-theme-clicked'),
  AISG_HOVERED_SECTION_CONTROLS_CLICKED: makeContextualEventName(
    'aisg-hovered-section-controls-clicked'
  ),
  AISG_THEME_TUTORIAL_TRIGGERED: makeContextualEventName(
    'aisg-theme-tutorial-triggered'
  ),
  AISG_PAGE_TUTORIAL_TRIGGERED: makeContextualEventName(
    'aisg-page-tutorial-triggered'
  ),
  AISG_FTU_TUTORIAL_TRIGGERED: makeContextualEventName(
    'aisg-ftu-tutorial-triggered'
  ),
  AISG_SECTION_TUTORIAL_TRIGGERED: makeContextualEventName(
    'aisg-section-tutorial-triggered'
  ),
  PREVIEW_SITE_TUTORIAL_TRIGGERED: makeContextualEventName(
    'preview-site-tutorial-triggered'
  ),
  REALTIME_ONBOARDING_VIEWED: makeContextualEventName(
    'realtime-onboarding-viewed'
  ),
  ORION_SYNC_STYLES_TRIGGERED: makeContextualEventName(
    'orion-sync-styles-triggered'
  ),
  ORION_ADD_CONTEXT_POPOVER_TRIGGERED: makeContextualEventName(
    'orion-add-context-popover-triggered'
  ),
  ORION_SITE_ADD_SECTION_TUTORIAL_TRIGGERED: makeContextualEventName(
    'orion-site-add-section-tutorial-triggered'
  ),
  ORION_SITE_CHANGE_LAYOUT_TUTORIAL_TRIGGERED: makeContextualEventName(
    'orion-site-change-layout-tutorial-triggered'
  ),
  ORION_SITE_GENERATE_PAGE_TUTORIAL_TRIGGERED: makeContextualEventName(
    'orion-site-generate-page-tutorial-triggered'
  ),
  ORION_SITE_PUBLISH_TUTORIAL_TRIGGERED: makeContextualEventName(
    'orion-site-publish-tutorial-triggered'
  ),
  AIDA_ELEMENT_ADDED_TO_CANVAS: makeContextualEventName(
    'aida-element-added-to-canvas'
  ),
  PAGES_PANEL_VIEWED: makeContextualEventName('pages-panel-viewed'),
};
const makeContextualTutorialName = (input: string) =>
  `__contextual_tutorial__${input}`;
export const CONTEXTUAL_TUTORIALS = {
  BOX_MODEL: makeContextualTutorialName('box-model'),
  CLASSES: makeContextualTutorialName('classes'),
  CMS: makeContextualTutorialName('cms'),
  LIBRARIES: makeContextualTutorialName('libraries'),

  ADD_LOCALES_CHECKLIST: makeContextualTutorialName('add-locales-checklist'),
  CLASSES_CHECKLIST: makeContextualTutorialName('classes-checklist'),
  CMS_BLANK_CHECKLIST: makeContextualTutorialName('cms-blank-checklist'),
  CMS_TEMPLATE_CHECKLIST: makeContextualTutorialName('cms-template-checklist'),
  IMAGES_CHECKLIST: makeContextualTutorialName('images-checklist'),
  NAVIGATOR_CHECKLIST: makeContextualTutorialName('navigator-checklist'),
  STYLES_CHECKLIST: makeContextualTutorialName('styles-checklist'),
  SPACING_CHECKLIST: makeContextualTutorialName('spacing-checklist'),
  _EXPERIMENTAL_ADD_ELEMENTS_CHECKLIST: makeContextualTutorialName(
    '_experimental_add-elements-checklist'
  ),
  _CHECKLIST_DRAG_QS: makeContextualTutorialName(
    '_experimental_nest-elements-checklist'
  ),
  LAYOUT_ELEMENT: makeContextualTutorialName('layout-element'),
  FLEX_NINE_BOX: makeContextualTutorialName('flex-nine-box'),
  GRID_NINE_BOX: makeContextualTutorialName('grid-nine-box'),
  PREVIEW_SITE: makeContextualTutorialName('preview-site'),
  AISG_THEME: makeContextualTutorialName('aisg-theme'),
  AISG_PAGE: makeContextualTutorialName('aisg-page'),
  AISG_FTU_TUTORIAL: makeContextualTutorialName('aisg-ftu-tutorial'),
  AISG_SECTION: makeContextualTutorialName('aisg-section'),
  ORION_SYNC_STYLES: makeContextualTutorialName('orion-sync-styles'),
  ORION_ADD_CONTEXT_POPOVER: makeContextualTutorialName(
    'orion-add-context-popover'
  ),
  ORION_DEPLOY_MODAL: makeContextualTutorialName('orion-deploy-modal'),
  ORION_THEME_PANEL: makeContextualTutorialName('orion-theme-panel'),
  ORION_SITE_ADD_SECTION: makeContextualTutorialName('orion-site-add-section'),
  ORION_SITE_CHANGE_LAYOUT: makeContextualTutorialName(
    'orion-site-change-layout'
  ),
  ORION_SITE_GENERATE_PAGE: makeContextualTutorialName(
    'orion-site-generate-page'
  ),
  ORION_SITE_PUBLISH: makeContextualTutorialName('orion-site-publish'),
  PAGES_PANEL_TUTORIAL: makeContextualTutorialName('pages-panel-tutorial'),
  EDITOR_ROLE_ONBOARDING: makeContextualTutorialName('editor-role-onboarding'),
  MARKETER_ROLE_ONBOARDING: makeContextualTutorialName(
    'marketer-role-onboarding'
  ),
  AEO_ANALYZE_IPN: makeContextualTutorialName('aeo-analyze-ipn'),
  AEO_NON_ANALYZE_IPN: makeContextualTutorialName('aeo-non-analyze-ipn'),
  OPEN_CANVAS_TUTORIAL: makeContextualTutorialName('open-canvas-tutorial'),
};

export const CHECKLIST_STATE = {
  OPEN: 'open' as const,
  MINIMIZED: 'minimized' as const,
  DISMISSED: 'dismissed' as const,
} as const;

export const ONBOARDING_SETTINGS_SOURCES = {
  CHECKLIST: 'checklist' as const,
  SETTINGS_PANEL: 'settingsPanel' as const,
  LAYOUT_PRESETS_PANEL: 'layoutPresetsPanel' as const,
} as const;

export const DISPLAY_SETTINGS_VIDEO_TUTORIAL_ID = 'LxVXkJXbCYo';
export const DISPLAY_SETTINGS_VIDEO_TUTORIAL_TITLE = 'Display Settings';
export const CHECKLIST = 'checklist';

export const QUICK_STACK_VIDEO_TUTORIAL_ID = '6C3YF9zulTg';
export const QUICK_STACK_VIDEO_TUTORIAL_TITLE = 'Quick Stack';
